import React from 'react';
import { CheckpointCardProps } from '@magoosh/gre/organisms/checkpoint_card/types';
import { StudyPlanCheckpoint } from '../types';
import CheckpointCard from '@magoosh/gre/organisms/checkpoint_card';
import CelebrationAstronautIllustration from '@magoosh/gre/adaptive_prep_v1/assets/celebration_astronaut.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  checkpoint: StudyPlanCheckpoint;
  dismissRefresh: () => void;
  refreshPlan: () => void;
}

const PrioritizedRefreshCheckpoint: React.FC<Props> = ({ checkpoint, dismissRefresh, refreshPlan }) => {
  const primaryCTA = {
    text: 'Refresh My Study Plan',
    variant: 'secondary',
    onClick: refreshPlan,
    target: '_blank'
  };

  const secondaryCTA = (
    <a
      className="u-margin-H-xs"
      style={{ color: colors.grayDarker }}
      onClick={dismissRefresh}
    >
      Dismiss
    </a>
  );

  const children = (
    <p>
      Refresh your study plan now to get new priorities based on your latest completed checkpoint. Self-selected and tutor-recommended topics will remain at the top of your study plan.
    </p>
  );

  const checkpointProps: CheckpointCardProps = {
    children,
    headline: 'Your Study Plan Just Got Better!',
    iconType: 'Complete',
    illustration: <img src={CelebrationAstronautIllustration} alt="Astronaut celebrating in space" />,
    isWrapped: true,
    primaryCTA,
    secondaryCTA
  };

  return (
    <CheckpointCard {...checkpointProps} />
  );
};

export default PrioritizedRefreshCheckpoint;
